import { Action } from "..";
import { MaterialBase } from "../../types/materialBase";

export const MATERIAL_CHANGE = "MATERIAL_CHANGE";

export function setMaterial(material: MaterialBase): Action {
  return { type: MATERIAL_CHANGE, payload: material };
}
